import { defaultConfig, defineConfig, mergeConfigs } from '@chakra-ui/react';
import { slotRecipes, recipes } from './recipes';
import { semanticTokens } from './semantic-tokens';
import { tokens } from './tokens';

const themeConfig = defineConfig({
	theme: {
		tokens,
		recipes,
		slotRecipes,
		semanticTokens
	},
	globalCss: {
		'body': {
			color: { base: '{colors.neutral.800}', _dark: 'white' },
		},
	}
});

export const defaultThemeConfig = mergeConfigs(defaultConfig, themeConfig);